<app-loading-spinner
  *ngIf="isLoading"
  class="spinner-full-page"
/>

<mat-card
  *ngIf="!isLoading"
  class="full-content"
>
  <mat-card-title class="content-header">{{ customerName }} </mat-card-title>

  <mat-card-content class="content">
    <div
      id="back-button"
      style="margin-left: 20px; margin-right: 20px; display: flex; justify-content: flex-end"
    >
      <button
        class="back-button"
        mat-button
        (click)="back()"
      >
        <span
          matTooltip="Logout"
          class="material-icons"
        >
          close
        </span>
      </button>
    </div>

    <mat-card
      id="enquiry-details"
      class="section-card"
    >
      <mat-card-title class="section-header">Enquiry Details</mat-card-title>

      <mat-card-content class="grid-display-3 no-padding">
        <div class="grid-display-3">
          <p>Enquiry Number:</p>
          <p style="grid-column: span 2">
            <b>
              {{ enquiryBasicData.enquiryNum }}
            </b>
          </p>
        </div>

        <div class="grid-display-3">
          <p>Enquiry Date:</p>
          <p style="grid-column: span 2">
            <b>{{ enquiryBasicData.enquiryDate }}</b>
          </p>
        </div>

        <div class="grid-display-3">
          <p>Relationship Manager:</p>
          <p style="grid-column: span 2">
            <b>{{ relationshipManagerData.name }}</b>
          </p>
        </div>

        <div
          class="grid-display-6"
          style="grid-column: span 2"
        >
          <p>Delivery Address:</p>
          <p style="grid-column: span 4">
            <b>{{ enquiryBasicData.deliveryAddress }}</b>
          </p>
        </div>

        <div class="grid-display-3">
          <p>Delivery PIN Code:</p>
          <p style="grid-column: span 2">
            <b>{{ enquiryBasicData.deliveryPincode | pincodeNumberFormat }}</b>
          </p>
        </div>

        <app-report-issue-button
          [entityId]="customerOrderId"
          [entityType]="entityType"
          [isInternalUser]="false"
          [contactNumberWhatsapp]="relationshipManagerData.mobile"
        />

        <div class="empty-cell"></div>

        <app-share-requirements-button [publicId]="publicRequirementsId"> </app-share-requirements-button>
      </mat-card-content>
    </mat-card>

    <!-- <mat-card
      id="requirement-items"
      class="section-card normal-text"
    >
      <mat-card-title class="section-header">Requirement Items</mat-card-title>

      <div class="scroll-x-container">
        <table
          mat-table
          [dataSource]="orderItemDataSource"
        >
          <ng-container
            matColumnDef="category"
            [sticky]="true"
          >
            <th
              mat-header-cell
              *matHeaderCellDef
            >
              <b> Category </b>
            </th>

            <td
              mat-cell
              *matCellDef="let row"
            >
              {{ row.category }}
            </td>
          </ng-container>

          <ng-container matColumnDef="product">
            <th
              mat-header-cell
              *matHeaderCellDef
            >
              <b> Product </b>
            </th>

            <td
              mat-cell
              *matCellDef="let row"
            >
              {{ row.product }}
            </td>
          </ng-container>

          <ng-container matColumnDef="make">
            <th
              mat-header-cell
              *matHeaderCellDef
            >
              <b> Make </b>
            </th>

            <td
              mat-cell
              *matCellDef="let row"
            >
              {{ row.make }}
            </td>
          </ng-container>

          <ng-container matColumnDef="grade">
            <th
              mat-header-cell
              *matHeaderCellDef
            >
              <b> Grade </b>
            </th>

            <td
              mat-cell
              *matCellDef="let row"
            >
              {{ row.grade }}
            </td>
          </ng-container>

          <ng-container matColumnDef="brand">
            <th
              mat-header-cell
              *matHeaderCellDef
            >
              <b> Brand </b>
            </th>

            <td
              mat-cell
              *matCellDef="let row"
            >
              {{ row.brand }}
            </td>
          </ng-container>

          <ng-container matColumnDef="type">
            <th
              mat-header-cell
              *matHeaderCellDef
            >
              <b> Type </b>
            </th>

            <td
              mat-cell
              *matCellDef="let row"
            >
              {{ row.type }}
            </td>
          </ng-container>

          <ng-container matColumnDef="property">
            <th
              mat-header-cell
              *matHeaderCellDef
            >
              <b> Property </b>
            </th>

            <td
              mat-cell
              *matCellDef="let row"
            >
              {{ row.property }}
            </td>
          </ng-container>

          <ng-container matColumnDef="dimension">
            <th
              mat-header-cell
              *matHeaderCellDef
            >
              <b> Dimension </b>
            </th>

            <td
              mat-cell
              *matCellDef="let row"
            >
              {{ row.dimension }}
            </td>
          </ng-container>

          <ng-container matColumnDef="customDimensions">
            <th
              mat-header-cell
              *matHeaderCellDef
            >
              <b> Custom Dimensions </b>
            </th>

            <td
              mat-cell
              *matCellDef="let row"
            >
              {{ row.customDimensions }}
            </td>
          </ng-container>

          <ng-container matColumnDef="qty">
            <th
              mat-header-cell
              *matHeaderCellDef
            >
              <b> Quantity </b>
            </th>

            <td
              mat-cell
              *matCellDef="let row"
            >
              {{ row.qty }}
            </td>
          </ng-container>

          <tr
            mat-header-row
            *matHeaderRowDef="requirementItemColumns"
          ></tr>

          <tr
            mat-row
            *matRowDef="let row; columns: requirementItemColumns"
            class="mat-row"
          ></tr>
        </table>
      </div>
    </mat-card> -->

    <mat-card
      id="quotes"
      class="section-card"
    >
      <mat-card-title class="section-header">Quotes </mat-card-title>

      <div
        *ngFor="let row of quotationList; let i = index"
        class="grid-display-6"
        style="gap: 10px"
      >
        <p>{{ row.quotationNum }}</p>

        <button
          mat-button
          class="file-download-button"
          [disabled]="!row.quotationPdfUrl"
          (click)="onFileDownloadNoAuth(row.quotationPdfUrl)"
          title="Quotation file download"
        >
          Quotation File
        </button>

        <p style="grid-column: span 3">{{ row.quotationMessage }}</p>
      </div>
    </mat-card>

    <mat-card
      id="invoices"
      class="section-card"
    >
      <mat-card-title class="section-header">Invoices</mat-card-title>

      <app-loading-spinner *ngIf="invoicesDataLoader" />

      <div
        class="grid-display-6"
        style="gap: 10px"
      >
        <ng-container *ngFor="let row of invoiceList; let i = index">
          <p>{{ row.invoiceNum }}</p>

          <div class="chips">
            <mat-chip
              class="status-chip"
              [ngClass]="getInvoiceStatusChipClass(row.invoiceDeliveryStatus)"
            >
              {{ row.invoiceDeliveryStatus?.value }}
            </mat-chip>
          </div>

          <p style="text-align: center">&#8377; {{ row.totalInvoiceAmount }}</p>

          <button
            mat-button
            class="file-download-button"
            [disabled]="!row.customerInvoiceFileUrl"
            (click)="onFileDownloadNoAuth(row.customerInvoiceFileUrl)"
            title="Invoice File file download"
          >
            Invoice File
          </button>

          <button
            mat-button
            class="file-download-button"
            [disabled]="!row.materialTestCertificateFileUrl"
            (click)="onFileDownloadAuth(row.materialTestCertificateFileUrl)"
            title="Material Test Certificate file download"
          >
            Material Test Certificate
          </button>

          <button
            mat-button
            class="file-download-button"
            [disabled]="!row.customerInvoiceFileUrl"
            (click)="onFileDownloadNoAuth(row.customerInvoiceFileUrl)"
            title="Invoice File file download"
          >
            GRN File
          </button>
        </ng-container>
      </div>
      <mat-paginator
        #invoicePaginator
        [hidePageSize]="true"
        [pageSize]="invoicesPageSize"
        (page)="onChangePage($event)"
        [length]="invoicesDataLength"
      />
    </mat-card>

    <mat-card
      id="relationship-manager"
      class="section-card"
    >
      <div class="rm">
        <mat-card-title class="section-header">Relationship Manager</mat-card-title>
        <p>
          <b>{{ relationshipManagerData.name }}</b>
        </p>

        <div class="grid-display-12">
          <p>Email:</p>
          <p style="grid-column: span 5">{{ relationshipManagerData.email }}</p>

          <p>Mobile:</p>
          <p style="grid-column: span 5">{{ relationshipManagerData.mobile | mobileNumberFormat }}</p>
        </div>
      </div>

      <div
        class="rm-senior"
        style="margin-top: 2rem"
        *ngIf="relationshipManagerSeniorData"
      >
        <mat-card-title class="section-header">Escalation Manager </mat-card-title>

        <p>
          <b>{{ relationshipManagerSeniorData.name }}</b>
        </p>

        <div class="grid-display-12">
          <p>Email:</p>
          <p style="grid-column: span 5">{{ relationshipManagerSeniorData.email }}</p>

          <p>Mobile:</p>
          <p style="grid-column: span 5">{{ relationshipManagerSeniorData.mobile | mobileNumberFormat }}</p>
        </div>
      </div>
    </mat-card>
  </mat-card-content>
</mat-card>
